export const GOOGLE_RECAPTCHA_V3_SITE_KEY = '6LcpHbcUAAAAAIDbsCEMPBB-n6udzo2UUQ2FAFl-';
export const GOOGLE_ANALYTICS_TRACKING_ID = 'UA-147981412-1';